//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ad01 from '@/assets/ad-chuyi.jpg'
import ad02 from '@/assets/ad-yuanggongquan.jpg'
import ad03 from '@/assets/ad-funvjie.png'
import config from '@/config/index'
import { getActivitylist, getNewslistAll, getCategory } from '@/api/youzheng.js'
export default {
  name: 'yougongle',
  data () {
    return {
      jnhlist: [],
      newslists: [],
      baseUrl: config.baseUrl,
      activity: 0,
      currentTime: '',
      ad01: ad01,
      ad02: ad02,
      ad03: ad03
    }
  },
  created () {
    this.newslist()
    this.getActivity()
  },
  components: {
  },
  mounted () {
    let timestamp = (new Date()).getTime()
    this.currentTime = timestamp
  },
  methods: {
    gotoContent (index, category) {
      if (index == 4) {
        this.$router.push({ name: 'youwenhua', params: { selected: 1, category: category } })
      } else if (index == 1) {
        this.$router.push({ name: 'youwenhua', params: { selected: 4, category: category } })
      } else {
        this.$router.push({ name: 'youwenhua', params: { selected: index, category: category } })
      }
    },
    getActivity () {
      getActivitylist({
        page: 1,
        rows: 3
      }).then(res => {
        if (res.returnValue.rows !== '' && res.returnValue.rows.length > 0) {
          this.jnhlist = res.returnValue.rows
        }
        this.jnhlist.forEach((item, index) => {
          item.signstartdate = item.signstartdate.replace(/-/g, '/')
          item.signenddate = item.signenddate.replace(/-/g, '/')
          item.signstartdate = new Date(item.signstartdate).getTime()
          item.signenddate = new Date(item.signenddate).getTime()
          if (parseInt(this.currentTime) < parseInt(item.signenddate) && parseInt(this.currentTime) >= parseInt(item.signstartdate)) {
            this.$set(this.jnhlist[index], 'activity', 1)
            return false
          }
          if (parseInt(this.currentTime) < parseInt(item.signstartdate)) {
            this.$set(this.jnhlist[index], 'activity', 2)
            return false
          }
          if (parseInt(this.currentTime) >= parseInt(item.signenddate)) {
            this.$set(this.jnhlist[index], 'activity', 3)
            return false
          }
        })
      })
    },
    goDetail (item) {
      if (item.activity == 2) {
        let date1 = new Date() // 开始时间
        let date2 = item.signstartdate // 结束时间
        let date3 = date2 - date1.getTime() // 时间差的毫秒数
        // 计算出相差天数
        let days = Math.floor(date3 / (24 * 3600 * 1000))
        // 计算出小时数
        let leave1 = date3 % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
        let hours = Math.floor(leave1 / (3600 * 1000))
        // 计算相差分钟数
        let leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
        let minutes = Math.floor(leave2 / (60 * 1000))
        // 计算相差秒数
        let leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
        let seconds = Math.round(leave3 / 1000)

        this.$vux.toast.text('离开始时间还剩' + days + '天' + hours + '时' + minutes + '分' + seconds + '秒', 'middle')
      } else {
        if (item.link !== '') {
          window.location.href = item.link
        } else {
          this.$router.push({ name: 'tuanGouDetail', params: { id: item.id } })
        }
      }
    },
    newslist () {
      this.newslists = []
      getCategory({
        owner_type: this.$config.owner_type,
        CHANNELCODE: 'ch10',
        SHOWWECHAT: 1
      }).then(data => {
        if (data.obj.length > 0) {
          // this.newslists.push({ CATEGORYNAME: '《信》文学季刊', TITILEIMG: 'upload/2007/IMG/category/100418/mobiletitlepic.png' })
          this.newslists = data.obj
          let temp = this.newslists[1]
          this.newslists[1] = this.newslists[4]
          this.newslists[4] = temp
        }
      })
    }
  }
}
